var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commissioning-list pa-10"},[_c('title-page',[_vm._v(_vm._s(_vm.$t('onboarding.queue.title')))]),_c('p',{staticClass:"text-body-2 text--secondary mb-4"},[_vm._v(_vm._s(_vm.$t('onboarding.queue.subtitle')))]),_c('order-queue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }